import script from "./AddCupons.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCupons.vue?vue&type=script&setup=true&lang=js"

import "./AddCupons.vue?vue&type=style&index=0&id=5556a6c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5556a6c1"]])

export default __exports__